import CSVParametersBuilder from '../CSVParametersBuilder'
import CSVParametersSection from '../CSVParametersSection'
import CostCSVPreviewHeaderSection from './CostCSVPreviewHeaderSection'
import CostCSVPreviewGroupingSection from './CostCSVPreviewGroupingSection'
import CSVPreviewEmptySection from '../CSVPreviewEmptySection'
import CSVPreviewCostProfitLossAdditionalSection from '../CSVPreviewCostProfitLossAdditionalSection'
import {ReportColumnsFormatCostOfWork} from 'constants'
import CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy from './CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy'
import CostCSVPreviewOneLevelsColumnsStrategy from './CostCSVPreviewOneLevelsColumnsStrategy'
import CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy from './CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy'
import CostCSVPreviewUserByGroupsThreeLevels from './CostCSVPreviewUserByGroupsThreeLevels'
import CostCSVPreviewUserByGroupsOnlyColumnsStrategy from './CostCSVPreviewUserByGroupsOnlyColumnsStrategy'
import $ from 'jquery'
import {ReportGroupingLevel} from '../../../constants'

export default function CostCSVPreviewGenerator() {}

CostCSVPreviewGenerator.prototype.init = function()
{
    return this;
};

CostCSVPreviewGenerator.prototype.generatePreviewTable = function( reportParameters, reportParamsStringBuilder )
{
    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels( [
                                                                           reportParameters.firstGroupingLevel,
                                                                           reportParameters.secondGroupingLevel,
                                                                           reportParameters.thirdGroupingLevel
                                                                       ] );

    var columnsStrategy = this.getColumnsStrategy( reportParameters );
    var totalColumnsNum = numOfGroupingColumns + columnsStrategy.getNumOfDataColumns();
    var totalRowNum = 17;


    var table = document.createElement( "table" );
    table.className = "reportCsvPreviewTable cost";
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    var paramsBuilder = new CSVParametersBuilder().init();
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addCPParam( reportParameters.customersProjectsSelection, reportParamsStringBuilder );
    paramsBuilder.addUsersParam(reportParameters.userSelection, reportParamsStringBuilder);

    var parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum );

    parametersSection.addRows( tBody );

    var headerSection = new CostCSVPreviewHeaderSection().init( columnsStrategy,
                                                                reportParameters.firstGroupingLevel,
                                                                reportParameters.secondGroupingLevel,
                                                                reportParameters.thirdGroupingLevel,
                                                                numOfGroupingColumns );

    var groupingSection = new CostCSVPreviewGroupingSection().init(
                                                                reportParameters.firstGroupingLevel,
                                                                reportParameters.secondGroupingLevel,
                                                                reportParameters.thirdGroupingLevel,
                                                                numOfGroupingColumns,
                                                                columnsStrategy.getNumOfDataColumns(),
                                                                5 );



    var emptySection = new CSVPreviewEmptySection().init(1, totalColumnsNum);

    headerSection.addRows( tBody );
    groupingSection.addRows( tBody);
    emptySection.addRows(tBody);
    if (reportParameters.showLeaveTimeCosts || reportParameters.showOvertimeAddition )
    {
        new CSVPreviewCostProfitLossAdditionalSection().init(
                columnsStrategy.getNumOfDataColumns(),
                numOfGroupingColumns,
                reportParameters.showOvertimeAddition,
                reportParameters.showLeaveTimeCosts
        ).addRows( tBody );
    }
    this.addEmptySectionIfNeeded(totalRowNum, tBody, totalColumnsNum);
    return table;
};

CostCSVPreviewGenerator.prototype.getColumnsStrategy = function(reportParameters) {
    const showOthers = reportParameters.includeOtherUsersColumn
    const $reportPreviewPlaceholder = $("#reportPreviewPlaceholder")
    $reportPreviewPlaceholder.removeClass("resizeForScroll")

    if (reportParameters.columnsConfig === ReportColumnsFormatCostOfWork.USERS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            return new CostCSVPreviewTwoLevelsUsersOnlyColumnsStrategy().init(
                {
                    showSpentTime: reportParameters.showSpentTime,
                    showAverageRates: reportParameters.showAverageRates,
                    showUserRates: reportParameters.showUserRates,
                    showOthers: showOthers,
                }
            )
        } else {
            return new CostCSVPreviewOneLevelsColumnsStrategy().init(
                {
                    showAverageRates: reportParameters.showAverageRates,
                    headerLevelKey: "report.user",
                    showOthers: showOthers,
                }
            )
        }
    } else if (reportParameters.columnsConfig === ReportColumnsFormatCostOfWork.GROUPS_ONLY) {
        if (reportParameters.showSpentTime || reportParameters.showAverageRates) {
            return new CostCSVPreviewTwoLevelsGroupsOnlyColumnsStrategy().init(
                {
                    showSpentTime: reportParameters.showSpentTime,
                    showAverageRates: reportParameters.showAverageRates,
                    showOthers: showOthers,
                }
            )
        } else {
            return new CostCSVPreviewOneLevelsColumnsStrategy().init(
                {
                    showAverageRates: reportParameters.showAverageRates,
                    headerLevelKey: "user.group",
                    showOthers: showOthers,
                })
        }
    } else {
        if (reportParameters.showSpentTime || reportParameters.showUserRates) {
            let columnsCount = 0;
            if (reportParameters.showSpentTime) columnsCount++
            if (reportParameters.showAverageRates) columnsCount++
            if (reportParameters.showUserRates) columnsCount++
            if (reportParameters.showSubtotalsByDepartments) columnsCount++
            if (showOthers) columnsCount++

            const twoGroupingLevels = reportParameters.firstGroupingLevel !== ReportGroupingLevel.NONE
                                      && reportParameters.secondGroupingLevel !== ReportGroupingLevel.NONE
            if (columnsCount === 5 || columnsCount === 4 && twoGroupingLevels) {
                $reportPreviewPlaceholder.addClass("resizeForScroll")
            }
            return new CostCSVPreviewUserByGroupsThreeLevels().init({
                    showSpentTime: reportParameters.showSpentTime,
                    showAverageRates: reportParameters.showAverageRates,
                    showUserRates: reportParameters.showUserRates,
                    showSubtotalsByDepartments: reportParameters.showSubtotalsByDepartments,
                    showOthers: showOthers,
                }
            )
        } else {
            return new CostCSVPreviewUserByGroupsOnlyColumnsStrategy().init(
                {
                    showAverageRates: reportParameters.showAverageRates,
                    showSubtotalsByDepartments: reportParameters.showSubtotalsByDepartments,
                    showOthers: showOthers,
                }
            )
        }
    }
}

CostCSVPreviewGenerator.prototype.addEmptySectionIfNeeded = function ( totalRowsNum, tBody, totalColumnsNum )
{
    var numOfEmptyRows = totalRowsNum + 1 - tBody.childNodes.length;
    if ( numOfEmptyRows > 0 )
        new CSVPreviewEmptySection().init( numOfEmptyRows, totalColumnsNum ).addRows( tBody );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewGenerator.js